var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rights-page"},[_c('h2',[_vm._v("请在微信上打开扫一扫功能扫码二维码并进行操作，非微信扫一扫暂不支持")])])
}]

export { render, staticRenderFns }